import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "location-settings" }
const _hoisted_2 = { class: "rounded shadow-lg modal-content-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mx-3 pt-2 mb-1 fw-bold" }, "Settings", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_5 = { class: "form-group form-check custom-checkbox m-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "automatic-update"
}, " Update Location automatically ", -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_8 = { class: "form-group zip-input-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "patient-first-name",
  class: "mx-3 mt-3 mb-1 fw-bold"
}, [
  /*#__PURE__*/_createTextVNode(" Location "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_11 = ["disable"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 1,
  class: "invalid-feedback d-block mx-3"
}
const _hoisted_14 = { class: "mt-2 mx-3 d-flex justify-content-end" }
const _hoisted_15 = { class: "form-group mt-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "mx-3 mb-1 fw-bold" }, [
  /*#__PURE__*/_createTextVNode("Temperature "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_18 = {
  class: "btn-group btn-group-toggle m-3",
  "data-bs-toggle": "buttons"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  hidden: "",
  name: "is-current",
  autocomplete: "off"
}, null, -1 /* HOISTED */)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Celsius ")
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  hidden: "",
  name: "is-current",
  autocomplete: "off"
}, null, -1 /* HOISTED */)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Fahrenheit ")
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_26 = { class: "mt-1 d-flex p-3 justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          id: "automatic-update",
          class: "form-check-input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.automaticUpdate) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelCheckbox, _ctx.automaticUpdate]
        ]),
        _hoisted_6
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _hoisted_10,
        (_ctx.showLocation)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(`px-3 py-2 d-flex justify-content-between ${_ctx.automaticUpdate ? 'disable' : ''}`),
              disable: _ctx.automaticUpdate
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.city) + ", " + _toDisplayString(_ctx.state), 1 /* TEXT */),
              _createElementVNode("i", {
                class: "fas fa-edit",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showEditZipCode()))
              })
            ], 10 /* CLASS, PROPS */, _hoisted_11))
          : _createCommentVNode("v-if", true),
        (_ctx.showEditZipCodeInput)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(`form-control m-3 mb-0 w-75 ${_ctx.zipError ? 'border border-danger' : ''}`),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.zip) = $event)),
                placeholder: "Zip Code (Ex: 12345)"
              }, null, 2 /* CLASS */), [
                [_vModelText, _ctx.zip]
              ]),
              (_ctx.zip)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "fas fa-times clear-search",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearZip()))
                  }))
                : _createCommentVNode("v-if", true),
              (_ctx.zipError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Enter a Valid Zip Code"))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.zipNotEntered())),
                  type: "button",
                  class: "btn btn-xs me-2 btn-outline-primary"
                }, " Cancel ")
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("label", {
            class: _normalizeClass(`btn btn-outline-primary font-size-xs ${_ctx.isCurrent ? 'active' : ''}`),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setIsCurrent(true)))
          }, _hoisted_21, 2 /* CLASS */),
          _createElementVNode("label", {
            class: _normalizeClass(`btn btn-outline-primary font-size-xs ${_ctx.isCurrent ? '' : 'active'}`),
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setIsCurrent(false)))
          }, _hoisted_24, 2 /* CLASS */)
        ])
      ]),
      _hoisted_25,
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("button", {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.cancel())),
          type: "button",
          class: "btn btn-xs me-2 btn-outline-primary"
        }, "Cancel"),
        _createElementVNode("button", {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.save())),
          type: "button",
          class: "btn btn-xs btn-primary"
        }, "Save")
      ])
    ])
  ]))
}